<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator="/">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>堆雪球管理</el-breadcrumb-item>
      <el-breadcrumb-item>微信列表</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 卡片视图区 -->
    <el-card class="box-card">
      <div  slot="header" class="flexContainer">
        <span  class="cardHeader">微信列表</span>
        <el-button style="float:right;" type="primary" size="normal" @click="getList(true)">刷新</el-button>
      </div>

      <!-- 表格区域 -->
      <el-table :data="list" border style="width: 100%">
        <el-table-column type="index" label="序号" width="50"></el-table-column>
        <el-table-column prop="id" label="头像" width="100">
          <template slot-scope="scope">
            <el-image :src="scope.row.avatar" fit="fill" :preview-src-list="[scope.row.avatar]" style="width: 50px; height: 50px;"></el-image>
          </template>
        </el-table-column>
        <el-table-column prop="nickname" label="微信昵称" width="200"></el-table-column>
        <el-table-column prop="alias" label="微信号" width="200"></el-table-column>
        <el-table-column prop="id" label="账号id"></el-table-column>
      </el-table>

      <!-- 分页区域 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="queryInfo.pageIndex + 1"
        :page-sizes="[10,20,50]"
        :page-size="queryInfo.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </el-card>

  </div>
</template>

<script>
export default {
  data () {
    return {
      list: [],
      queryInfo: {
        pageIndex: 0,
        pageSize: 10
      },
      total: 0
    }
  },
  created () {
    // this.base = window.sessionStorage.getItem('base')
    this.getList()
  },
  methods: {
    // 获取列表
    async getList (reset = false) {
      if (reset) this.queryInfo.pageIndex = 0
      const { data: res } = await this.$http.get('duixueqiu/weixinList', { params: this.queryInfo })
      if (res.meta.status !== 200) return this.$message.error(res.meta.msg)
      this.list = res.data.list
      this.total = res.data.total
    },

    // 监听pagesize改变的事件
    handleSizeChange (newSize) {
      this.queryInfo.pageSize = newSize
      this.getList()
    },

    // 监听页码改变
    handleCurrentChange (newPage) {
      this.queryInfo.pageIndex = newPage - 1
      this.getList()
    }

  }
}
</script>

<style lang="less" scoped>

</style>
